var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50172 12.9746C9.78589 13.2272 10.2141 13.2272 10.4983 12.9746L17.1678 7.04613C17.3742 6.86268 17.6902 6.88127 17.8737 7.08766C18.0572 7.29405 18.0386 7.61008 17.8322 7.79354L11.1626 13.722C10.4996 14.3114 9.50041 14.3114 8.83736 13.722L2.16781 7.79354C1.96142 7.61008 1.94283 7.29405 2.12629 7.08766C2.30975 6.88127 2.62579 6.86268 2.83218 7.04613L9.50172 12.9746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenImage);
export default __webpack_public_path__ + "static/media/hiddenImage.f0bd52c63122b095eabdc74874d2ecd6.svg";
export { ForwardRef as ReactComponent };